module.exports = __webpack_public_path__ + "static/media/logo.4ecd6960.png";